import React, { useState, useEffect, useCallback } from 'react';
import DashboardCompras from './purchase-analysis-components';
// La función GetPurchaseAnalysis ahora aceptará los parámetros de fecha
import {GetMarginAnalysis, GetPurchaseAnalysis} from '../../../../services/purchaseServices';
import moment from "moment";
import { RangoFechas } from '../../../../helpers/datesHelper';
import Authorization from "../../../utils/secure/Authorization";
import NavBar from "../../../utils/nav/NavBar";
import NavMenu from "../../../utils/nav/NavMenu";

const AnalisisComprasPage = () => {
    const [permissionChecked, setPermissionChecked] = useState(false);
    const [purchaseData, setPurchaseData] = useState(null);
    const [historicalData, setHistoricalData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');

    // El estado de las fechas ahora se inicializa dinámicamente con valores por omisión (hoy)
    const initialRange = new RangoFechas();
    const [startDate, setStartDate] = useState(initialRange.Desde);
    const [endDate, setEndDate] = useState(initialRange.Hasta);
    
    const [marginAnalysis, setMarginAnalysis] = useState(null);

    const fetchMarginAnalysis = async () => {
        const margin = await GetMarginAnalysis();
        setMarginAnalysis(margin.productMargin);
    }
    
    // Usamos useCallback para evitar que la función se recree innecesariamente
    const fetchData = useCallback(async (start, end) => {
        try {
            setIsLoading(true);
            setError('');
            // Pasamos las fechas al método que llama a la API
            const startDateString = moment(start);
            const endDateString = moment(end);
            
            const { details, historicalData } = await GetPurchaseAnalysis(startDateString, endDateString);
                        
            setPurchaseData(details);
            setHistoricalData(historicalData);
        } catch (err) {
            setError("No se pudieron cargar los datos del análisis de compras. Intenta de nuevo más tarde.");
        } finally {
            setIsLoading(false);
        }
    }, []);

    // Carga inicial solamente una vez
    useEffect(() => {
        fetchData(startDate, endDate);
        fetchMarginAnalysis();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onDatesChanged = (rangoFechas) => {
        // Normaliza y actualiza el rango de fechas, luego carga datos una sola vez
        const desde = new Date(rangoFechas.Desde);
        desde.setHours(0, 0, 0, 0);
        const hasta = new Date(rangoFechas.Hasta);
        hasta.setHours(23, 59, 59, 999);

        setStartDate(desde);
        setEndDate(hasta);
        fetchData(desde, hasta);
    };

    if (isLoading) {
        return <div style={{ padding: '20px', fontFamily: 'sans-serif' }}>Cargando datos del reporte...</div>;
    }

    if (error) {
        return <div style={{ padding: '20px', fontFamily: 'sans-serif', color: 'red' }}>{error}</div>;
    }

    return (
        <div>
            {!permissionChecked && (
                <Authorization
                    permission="Compras/DashboardCompras"
                    onPermissionGranted={() => setPermissionChecked(true)}
                />
            )}
            <div className="page-header">
                <NavBar
                    title="Análisis de compras"
                    navButtonComponent={<NavMenu />}
                />
            </div>
            {/* Pasamos los datos y los manejadores de fechas al componente del dashboard */}
            <DashboardCompras
                initialData={purchaseData}
                historicalData={historicalData}
                productMarginAnalysis={marginAnalysis}
                startDate={startDate}
                endDate={endDate}
                onStartDateChange={setStartDate}
                onEndDateChange={setEndDate}
                onDatesChanged={onDatesChanged}
            />
        </div>
    );
};

export default AnalisisComprasPage;

